import { render, staticRenderFns } from "./HomeDealPageWidget.vue?vue&type=template&id=68115b15&scoped=true"
import script from "./HomeDealPageWidget.vue?vue&type=script&lang=js"
export * from "./HomeDealPageWidget.vue?vue&type=script&lang=js"
import style0 from "./HomeDealPageWidget.vue?vue&type=style&index=0&id=68115b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68115b15",
  null
  
)

export default component.exports